(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-popup"] && !Shopify.designMode) return;
  try {
    
  const STORAGE_KEY = 'vasha-discount-popup-dismissed';

  function initDiscountPopup() {
    if (localStorage.getItem(STORAGE_KEY)) return;

    const section = document.getElementById('discount-popup-section');
    const parsedDelay = parseInt(section?.dataset.delay, 10);
    const DELAY_MS = (Number.isFinite(parsedDelay) ? parsedDelay : 5) * 1000;
    if (!section) return;

    setTimeout(() => {
      if (localStorage.getItem(STORAGE_KEY)) return;
      section.showDialog();

      section.addEventListener('dialog:close', () => {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      }, { once: true });
    }, DELAY_MS);
  }

  if (document.readyState === 'complete') {
    initDiscountPopup();
  } else {
    window.addEventListener('load', initDiscountPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
